import React from "react";
import { Redirect, Route } from "react-router-dom";
import RescoStorage from "../../../utils/rescoStorage";

const PrivateRoute: React.FC<{
  component: React.FC;
  path: string;
  exact: boolean;
}> = (props) => {
  return RescoStorage.getSession() != null ? (
    <Route path={props.path} exact={props.exact} component={props.component} />
  ) : (
    <Redirect to="/login" />
  );
};

PrivateRoute.displayName = "PrivateRoute";

export default PrivateRoute;
